import {inject, injectable} from 'inversify';

import type {Expand, MaybeExpanded} from '../../../../api/types';
import type {SubtenantMapperJrpc} from '../../Subtenant/mappers/Subtenant.mapper.jrpc';

import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class TenantExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {tenant: ['subtenant_ids']};
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace TenantExpandJrpc {
  export type ExpandedFields = {
    subtenants: MaybeExpanded<SubtenantMapperJrpc.ApiData>[];
  };
}
